import { useContext } from 'react';
import { ExperimentContext } from './ExperimentContext';
import type { ExperimentContextType } from '../../experiments/types';

export function useExperimentContext(): ExperimentContextType {
  const ctx = useContext(ExperimentContext);
  if (ctx === null) {
    throw new Error('useExperimentContext must be used within an ExperimentProvider');
  }
  return ctx;
}
